export const eventPath = (ev) => `/rsvp/${ev?.slug || ev?.id}`;
export const eventUrl = (ev) => `${window.location.origin}${eventPath(ev)}`;
export const eventShareUrl = (ev) => `${window.location.origin}/api/share/${ev?.slug || ev?.id}`;
export const canonicalEventUrl = (ev) => `${process.env.REACT_APP_PUBLIC_SITE_URL}${eventPath(ev)}`;

export const toSlug = (text) =>
  (text || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/['\u2019`]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);

export async function copyText(text) {
  await navigator.clipboard.writeText(text);
}
